import React from 'react'
import { useNavigate } from 'react-router-dom'
import Switchy from './Switchy'
import '../styles/Header.css'
import texts from '../texts'

const Header = ({ switchRef, menuVisible, handleToggleMenu, darkMode, setDarkMode }) => {
  const navigate = useNavigate()

  return (
    <header className='main-header'>
      <div className='header-toggle' ref={switchRef} onClick={handleToggleMenu}>
        <Switchy checked={menuVisible} onChange={handleToggleMenu} inputRef={switchRef} />
      </div>
      {/* <div style={{ marginLeft: 'auto', paddingRight: '10px' }}>
        <Switch title='modo oscuro' checked={darkMode} onChange={() => setDarkMode((v) => !v)} />
      </div> */}
      <button
        onClick={() => navigate('/buscar')}
        className={`header-search-button ${darkMode ? 'dark-mode' : 'light-mode'}`}
        title='Buscar vocabulario'
      >
        <svg
          width='20'
          height='20'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <circle cx='11' cy='11' r='8'></circle>
          <path d='m21 21-4.35-4.35'></path>
        </svg>
        {texts.header.search}
      </button>
    </header>
  )
}

export default Header
